// Logo Service — single source of truth for the active client logo.
// To rebrand: update CLIENT_LOGO_URL and CLIENT_NAME below.
const CLIENT_LOGO_URL = '/saheeh_logo_w.svg';
const CLIENT_NAME     = 'SAHEEH';

export class LogoService {
  static getLogoUrl(): string {
    return CLIENT_LOGO_URL;
  }

  static getLogoBase64(): string {
    return '';
  }

  static async addLogoToPDF(doc: any, x: number = 85, y: number = 25, width: number = 40, height: number = 20): Promise<void> {
    try {
      const response = await fetch(CLIENT_LOGO_URL);
      if (!response.ok) throw new Error(`fetch failed: ${response.status}`);
      const blob = await response.blob();
      const logoData = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      doc.addImage(logoData, 'PNG', x, y, width, height);
    } catch {
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text(CLIENT_NAME, x + width / 2, y + height / 2, { align: 'center' });
    }
  }
}
